import type { CountryCode } from 'libphonenumber-js/min';
import { Channel } from './channels';

export interface II18nEntry {
  channel: Channel;
  countryCode: CountryCode;
  currency: string;
  domain: string;
  iso: string;
  locale: string;
  availableCountryLocale: string;
  availableCountryCodes: CountryCode[];
}

export type Locale = 'fr' | 'de';

export const I18N: Record<Locale, II18nEntry> = {
  fr: {
    channel: Channel.FR,
    countryCode: 'FR',
    currency: 'EUR',
    domain: 'lafourche.fr',
    iso: 'fr_FR',
    locale: 'fr',
    availableCountryLocale: 'fr,mc,be,lu',
    availableCountryCodes: ['FR', 'MC', 'BE', 'LU'],
  },
  de: {
    channel: Channel.DE,
    countryCode: 'DE',
    currency: 'EUR',
    domain: 'ackerherz.de',
    locale: 'de',
    iso: 'de_DE',
    availableCountryLocale: 'de,at',
    availableCountryCodes: ['DE', 'AT'],
  },
};

export const I18N_DEFAULT = I18N.fr;
